import {assert} from './assert';

export function getCheckedRadioByName(name: string): HTMLInputElement
{
	const el = document.querySelector(`input[type=radio][name=${name}]:checked`) as HTMLInputElement;
	assert(el !== null);
	return el;
}

export function getRangeInputByName(name: string): HTMLInputElement
{
	const el = document.querySelector(`input[type=range][name=${name}]`) as HTMLInputElement;
	assert(el !== null);
	return el;
}

export function getRangeTickmarksByInputName(name: string): HTMLInputElement
{
	const el = document.querySelector(`input[type=range][name=${name}] + .tickmarks`) as HTMLInputElement;
	assert(el !== null);
	return el;
}

export function getSelectedOptionBySelectName(name: string): HTMLOptionElement
{
	const el = document.querySelector(`select[name=${name}] option:checked`) as HTMLOptionElement;
	assert(el !== null);
	return el;
}

export function getInputById(idSelector: string): HTMLInputElement
{
	const el = document.getElementById(idSelector) as HTMLInputElement;
	assert(el !== null);
	return el;
}
